import * as React from "react";
import PropTypes from "prop-types";

import { Card, Grid, Icon } from "@mui/material";
import SoftBox from "components/SoftBox";
import { useEffect, useState } from "react";
import SoftTypography from "components/SoftTypography";
import "assets/theme/base/animation.css";
import defaultTeamLogo from "assets/images/default_team_logo.png";

const globalCss = require("assets/theme/base/globals");
const _ = require("lodash");

function OponentsView({ event, openBackDrop, informParent }) {
  const [diffTimer, setDiffTimer] = useState(null);

  const css = globalCss ? globalCss.default : null;
  const customColors = css.customColors;

  function timeDifference(date1, date2) {
    var difference = date1.getTime() - date2.getTime();

    var daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
    difference -= daysDifference * 1000 * 60 * 60 * 24;

    var hoursDifference = Math.floor(difference / 1000 / 60 / 60);
    difference -= hoursDifference * 1000 * 60 * 60;

    var minutesDifference = Math.floor(difference / 1000 / 60);
    difference -= minutesDifference * 1000 * 60;

    var secondsDifference = Math.floor(difference / 1000);
    return (
      daysDifference + ":" + hoursDifference + ":" + minutesDifference + ":" + secondsDifference
    );
  }

  function countDiffUpdate() {
    if (event) {
      let now = new Date();
      let lastUpdate = new Date(event.fixtureInfo.lastUpdate);
      event.fixtureInfo.lastUpdateLabel = lastUpdate.toLocaleString("en-GB");
      event.fixtureInfo.diff = timeDifference(now, lastUpdate);
    }
  }

  useEffect(() => {
    if (event) {
      if (!diffTimer) {
        countDiffUpdate();
        let int = setInterval(countDiffUpdate, 1000);
        setDiffTimer(int);
      } else {
        clearInterval(diffTimer);
        setDiffTimer(null);
        countDiffUpdate();
        let int = setInterval(countDiffUpdate, 1000);
        setDiffTimer(int);
      }
    }
  }, [event]);

  useEffect(() => {
    if (!diffTimer) {
      let int = setInterval(countDiffUpdate, 1000);
      setDiffTimer(int);
    }
  }, []);

  useEffect(() => {
    return () => {
      if (diffTimer) clearInterval(diffTimer);
    };
  }, [diffTimer]);

  if (!event) return "";

  const hasScoreBoard = _.get(event, "live.scoreBoard");
  const hasTimeline =
    _.get(event, "live.timeline") &&
    event.live.timeline.length > 0 &&
    event.live.timeline.filter((te) => te.participant).length > 0;
  const hasVirtualCourt =
    _.get(event, "fixtureInfo.virtualCourtId") && event.fixtureInfo.status == "In progress";
  const hasStats = _.get(event, "fixtureInfo.statsId");

  return (
    <React.Fragment>
      <Card style={{ width: "100%", background: "rgb(57, 57, 57)", overflow: "hidden" }}>
        <div
          style={{ backgroundColor: "#ffffff80" }}
          className={event ? "fixture-header-" + event.fixtureInfo.sport.id : "fixture-header"}
        ></div>
        <div className="fixture-data">
          <SoftBox>
            <Grid
              container
              className="region-competion-breadcramp"
              sx={{
                padding: "2px 8px !important",
                alignItems: "center",
                minHeight: "24px",
              }}
            >
              <Grid
                item
                sm={7}
                sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", lineHeight: "1" }}
              >
                <SoftTypography
                  variant="caption"
                  style={{
                    display: event.providerName ? "" : "none",
                    fontSize: "0.62rem",
                    textShadow: "0px 0px 5px #cececece",
                  }}
                  sx={{
                    backgroundColor: customColors[event.providerName],
                    borderRadius: "50px",
                    minWidth: "55px",
                    boxShadow: "0px 0px 1px #ffffffa1",
                    padding: "2px 5px",
                    marginRight: "4px",
                    color: "#fff",
                    textShadow: "0px 0px 2px #000 !important",
                    lineHeight: "1.1",
                  }}
                >
                  {event.providerName || "-"}
                </SoftTypography>
                <Icon sx={{ paddingTop: "1px", fontSize: "0.8rem" }}>
                  keyboard_arrow_right_outlined_icon
                </Icon>
                <SoftTypography variant="caption" sx={{ color: "#fff", fontSize: "0.68rem" }}>
                  {_.get(event, "fixtureInfo.sport.name", "-")}
                </SoftTypography>
                <Icon sx={{ paddingTop: "1px", fontSize: "0.8rem" }}>
                  keyboard_arrow_right_outlined_icon
                </Icon>
                <SoftTypography variant="caption" sx={{ color: "#fff", fontSize: "0.68rem" }}>
                  {event.region || "-"}
                </SoftTypography>
                <Icon sx={{ paddingTop: "1px", fontSize: "0.8rem" }}>
                  keyboard_arrow_right_outlined_icon
                </Icon>
                <SoftTypography variant="caption" sx={{ color: "#fff", fontSize: "0.68rem" }}>
                  {event.league || "-"}
                </SoftTypography>
              </Grid>
              <Grid item sm={5} style={{ textAlign: "right", opacity: 0.7 }}>
                <SoftTypography
                  sx={{ fontSize: "0.7rem !important", color: "#fff", lineHeight: "1" }}
                >
                  Start Date: {event.date}
                </SoftTypography>
              </Grid>
            </Grid>
          </SoftBox>

          <SoftBox px={1} py={0.4}>
            <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
              <Grid item className="fixture-oponent" sx={{ minWidth: "42%", maxWidth: "42%" }}>
                <Grid
                  container
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "nowrap",
                    gap: "6px",
                  }}
                >
                  <Grid item sx={{ minWidth: 0 }}>
                    <SoftTypography
                      sx={{
                        color: "#fff",
                        fontSize: "0.72rem",
                        lineHeight: "1.1",
                        maxWidth: "170px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {event.home || "-"}
                    </SoftTypography>
                  </Grid>
                  <Grid item>
                    <img
                      className={
                        event.fixtureInfo.participants[0].logo
                          ? "participant-logo"
                          : "default-participant-logo"
                      }
                      style={{ width: "2.8rem", height: "2.8rem" }}
                      src={
                        event.fixtureInfo.participants[0].logo
                          ? event.fixtureInfo.participants[0].logo
                          : defaultTeamLogo
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item sx={{ minWidth: "120px", maxWidth: "120px", textAlign: "center" }}>
                <SoftTypography style={{ fontSize: "1.05rem", color: "#fff", lineHeight: "1" }}>
                  VS
                </SoftTypography>
                <SoftTypography style={{ fontSize: "0.7rem", color: "#fff", lineHeight: "1.1" }}>
                  {_.get(event, "fixtureInfo.status", "-")}
                </SoftTypography>
                <SoftTypography style={{ fontSize: "0.66rem", color: "#fff", lineHeight: "1.1" }}>
                  state:{" "}
                  {_.get(event, "live.scoreBoard.state")
                    ? _.get(event, "live.scoreBoard.state")
                    : "-"}
                </SoftTypography>
                <span
                  style={{
                    display: event.fixtureInfo.status == "In progress" ? "block" : "none",
                    width: "85px",
                    margin: "2px auto 0",
                  }}
                  className="playing-time"
                ></span>
              </Grid>

              <Grid item className="fixture-oponent" sx={{ minWidth: "42%", maxWidth: "42%" }}>
                <Grid
                  container
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "nowrap",
                    gap: "6px",
                  }}
                >
                  <Grid item>
                    <img
                      className={
                        event.fixtureInfo.participants[1].logo
                          ? "participant-logo"
                          : "default-participant-logo"
                      }
                      style={{ width: "2.8rem", height: "2.8rem" }}
                      src={
                        event.fixtureInfo.participants[1].logo
                          ? event.fixtureInfo.participants[1].logo
                          : defaultTeamLogo
                      }
                    />
                  </Grid>
                  <Grid item sx={{ minWidth: 0 }}>
                    <SoftTypography
                      sx={{
                        color: "#fff",
                        fontSize: "0.72rem",
                        lineHeight: "1.1",
                        maxWidth: "170px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {event.away || "-"}
                    </SoftTypography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </SoftBox>

          <SoftBox>
            <Grid
              container
              className="fixture-overview-footer"
              sx={{
                alignItems: "center",
                padding: "2px 8px !important",
                minHeight: "24px",
              }}
            >
              <Grid item sm={7} sx={{ textAlign: "left", opacity: 0.75 }}>
                <Grid
                  container
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "nowrap",
                    overflow: "hidden",
                  }}
                >
                  <SoftTypography variant="caption" sx={{ fontSize: "0.66rem", color: "#fff" }}>
                    Last Update:
                  </SoftTypography>
                  <SoftTypography
                    variant="caption"
                    sx={{
                      fontSize: "0.76rem",
                      color: "yellow",
                      paddingLeft: "4px",
                    }}
                  >
                    {_.get(event, "fixtureInfo.diff", "-")}
                  </SoftTypography>
                  <SoftTypography
                    variant="caption"
                    sx={{
                      fontSize: "0.62rem",
                      color: "#fff",
                      display: openBackDrop ? "none" : "",
                      paddingLeft: "4px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    ({event.fixtureInfo.lastUpdateLabel} locale time)
                  </SoftTypography>
                </Grid>
              </Grid>
              <Grid item sm={5} sx={{ color: "#fff" }}>
                <Grid
                  container
                  sx={{
                    justifyContent: "flex-end",
                    alignItems: "center",
                    flexWrap: "nowrap",
                    gap: "4px",
                  }}
                >
                  <Icon
                    style={{ cursor: "help", fontSize: "0.82rem" }}
                    className={hasScoreBoard ? "" : "disabled-form-item"}
                    title={hasScoreBoard ? "Scoreboard Available" : "Scoreboard NOT Available"}
                    onClick={(e) => informParent(e, "scoreboard")}
                  >
                    scoreboard_outlined_icon
                  </Icon>
                  <Icon
                    style={{ cursor: "help", fontSize: "0.82rem" }}
                    className={hasTimeline ? "" : "disabled-form-item"}
                    title={hasTimeline ? "Summary Available" : "Summary NOT Available"}
                    onClick={(e) => informParent(e, "timeline")}
                  >
                    format_list_bulleted_outlined_icon
                  </Icon>
                  <Icon
                    style={{ cursor: "help", fontSize: "0.82rem" }}
                    className={hasScoreBoard ? "" : "disabled-form-item"}
                    title={hasScoreBoard ? "Live Stats Available" : "Live Stats NOT Available"}
                    onClick={(e) => informParent(e, "liveStats")}
                  >
                    data_saver_off_outlined_icon
                  </Icon>
                  <Icon
                    style={{ cursor: "help", fontSize: "0.82rem" }}
                    className={hasVirtualCourt ? "" : "disabled-form-item"}
                    title={
                      hasVirtualCourt ? "Virtual-Court Available" : "Virtual-Court NOT Available"
                    }
                    onClick={(e) => informParent(e, "vlcourt")}
                  >
                    live_tv_outlined_icon
                  </Icon>
                  <Icon
                    style={{ cursor: "help", fontSize: "0.82rem" }}
                    className={hasStats ? "" : "disabled-form-item"}
                    title={
                      hasStats
                        ? "Pregame stats Available: " + _.get(event, "fixtureInfo.statsId")
                        : "Pregame stats NOT Available"
                    }
                    onClick={(e) => informParent(e, "stats")}
                  >
                    leaderboard_outlined_icon
                  </Icon>
                </Grid>
              </Grid>
            </Grid>
          </SoftBox>
        </div>
      </Card>
    </React.Fragment>
  );
}

// Typechecking props for the DataTable
OponentsView.propTypes = {
  event: PropTypes.object,
  openBackDrop: PropTypes.bool,
  informParent: PropTypes.func,
};

export default OponentsView;
